module.exports = __webpack_public_path__ + "img/ftc.d4f3e386.svg";